import { tokens, useTheme } from "../../glassTheme.tsx";

type Variant = "default" | "primary" | "ghost";

/** Opaque buttons — the sheet/input rule from §3 applies to controls too: crisp text, not blurred. */
export function GlassButton({
  variant = "default", disabled, onClick, children, fullWidth,
}: {
  variant?: Variant; disabled?: boolean; onClick?: () => void; children: React.ReactNode; fullWidth?: boolean;
}) {
  const { colors } = useTheme();
  const b = colors.button[variant];
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: "10px 16px", borderRadius: tokens.radius.pill,
        border: variant === "ghost" ? "none" : `1px solid ${b.border}`,
        background: b.bg, color: b.fg,
        fontFamily: tokens.font.sans, fontSize: tokens.type.button.size,
        cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.4 : 1,
        width: fullWidth ? "100%" : undefined, textAlign: "center",
      }}
    >{children}</button>
  );
}
